<footer class="footer mt-auto">
  <div class="container">
    <div class="footer-nav">
      <ul class="footer__sections" [ngClass]="menu()?.gridTemplateClasses">
        <!-- Section -->
        @for (section of menu()?.sections; track section) {
          <li class="footer__section" [ngClass]="section.gridItemClasses">
            <!-- Group -->
            @for (item of section.items; track item) {
              <ul class="footer__groups">
                <li class="footer__group footer-group">
                  <h4 class="footer-group__title">
                    <a
                      class="footer-group__link"
                      [routerLink]="['/' + item?.page?.pretty_url] | localize"
                      [externalLink]="item.page.external_url"
                      >{{ item?.page?.title || item?.page?.pretty_url }}
                    </a>
                  </h4>
                  <!-- Links -->
                  @if (item?.children?.length) {
                    <ul class="footer-group__item footer-links">
                      @for (child of item?.children; track child) {
                        <li class="footer-links__item">
                          <a
                            class="footer-nav-links__link"
                            [routerLink]="
                              ['/' + child?.page?.pretty_url] | localize
                            "
                            [externalLink]="child?.page.external_url"
                            [title]="child?.page?.short_content || ''"
                            >{{
                              child?.page?.title || child?.page?.pretty_url
                            }}</a
                          >
                        </li>
                      }
                    </ul>
                  }
                </li>
              </ul>
            }
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom__inner container">
      <div class="footer-copyright">
        <small [innerHTML]="'COPYRIGHT_TEXT' | translate">{{
          'BELPOST' | translate
        }}</small>
      </div>
      <div class="footer-social">
        <ul class="footer-social__list list-row">
          @for (item of items.buttons; track item) {
            <li class="footer-social__item">
              <a
                [href]="item?.link"
                target="_blank"
                rel="noopener"
                class="footer-button__link eye-hover"
                [title]="item?.text | translate"
                [attr.aria-label]="item?.text | translate"
              >
                <div class="footer-button__icon">
                  <fa-icon [icon]="iconMap.get(item?.type)" size="lg"></fa-icon>
                </div>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</footer>
